import Modal from "./modal";
import ThemeLogo from "../../ui/theme-logo";
import { PlansGrid } from "../plans/plans-grid";

type PlansModalProps = {
  isOpen: boolean;
  toggle: () => void;
};

/**
 * Full-viewport plans picker. Esc/X closes back to the editor (caller closes
 * any parent paywall as well). Checkout still redirects same-tab to Stripe.
 */
export default function PlansModal({ isOpen, toggle }: PlansModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      size="max-w-none w-[calc(100vw-1.5rem)] sm:w-[calc(100vw-2rem)] max-h-[calc(100vh-1.5rem)] sm:max-h-[calc(100vh-2rem)]"
      closeButton
    >
      <div className="max-w-[1120px] mx-auto w-full pb-4">
        <header className="pr-8 text-center max-w-2xl mx-auto">
          <div className="inline-block leading-none">
            <ThemeLogo height="28px" />
          </div>
          <h2
            id="modal-headline"
            className="mt-5 text-2xl sm:text-[1.75rem] font-semibold tracking-tight text-neutral-900 text-balance"
          >
            Simple plans. Start free, upgrade when you need more or live
            previews.
          </h2>
          <p className="mt-3 text-sm sm:text-[15px] text-neutral-500 leading-relaxed">
            Most people upgrade for unlimited exports and live client previews.
          </p>
        </header>
        <PlansGrid />
      </div>
    </Modal>
  );
}
